import _ from 'lodash';

export default class FAClaimExtension {
    constructor(claim) {
        Object.defineProperty(this, 'claim', {
            enumerable: false,
            value: claim
        });

        this.incidentReport = this.claim.lobs.farm
        && _.isBoolean(this.claim.lobs.farm.incidentReport)
            ? this.claim.lobs.farm.incidentReport
            : false;
        this.dateOfNotice = this.claim.lobs.farm
        && this.claim.lobs.farm.dateOfNotice
            ? this.claim.lobs.farm.dateOfNotice
            : null;
        this.fixedPropertyIncidents = this.claim.lobs.farm
        && this.claim.lobs.farm.fixedPropertyIncidents
            ? this.claim.lobs.farm.fixedPropertyIncidents
            : null;
    }
}
